var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M0 15.9995C0 24.8361 7.16344 31.9995 16 31.9995C24.8366 31.9995 32 24.8361 32 15.9995C32 7.16296 24.8366 -0.000488281 16 -0.000488281C7.16344 -0.000488281 0 7.16296 0 15.9995Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "facebook_2",
    d: "M24 15.9995C24 11.5995 20.4 7.99951 16 7.99951C11.6 7.99951 8 11.5995 8 15.9995C8 19.9995 10.9 23.2995 14.7 23.8995V18.2995H12.7V15.9995H14.7V14.1995C14.7 12.1995 15.9 11.0995 17.7 11.0995C18.6 11.0995 19.5 11.2995 19.5 11.2995V13.2995H18.5C17.5 13.2995 17.2 13.8995 17.2 14.4995V15.9995H19.4L19 18.2995H17.1V23.9995C21.1 23.3995 24 19.9995 24 15.9995Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.689eab5e6fccdc07457f20b8a54daeff.svg";
export { ForwardRef as ReactComponent };